import axios from "axios";
import {
  buildAssetsProbeUrl,
  buildExternalLinksProbeUrl,
} from "./useDocumentAvailability";

type PaginatedTotal = import("../../../../types/types").WithPagination<{
  data: unknown[];
}>;

export { buildAssetsProbeUrl, buildExternalLinksProbeUrl };

export async function productHasGeneratedAssetInstances(
  tenantId: string,
  productId: string
): Promise<boolean> {
  const [withGenerated, withoutGenerated] = await Promise.all([
    axios.get<PaginatedTotal>(
      buildAssetsProbeUrl("product", tenantId, productId, {
        includeGeneratedAssets: true,
      })
    ),
    axios.get<PaginatedTotal>(
      buildAssetsProbeUrl("product", tenantId, productId, {
        includeGeneratedAssets: false,
      })
    ),
  ]);

  return (
    (withGenerated.data.pagination?.total ?? 0) >
    (withoutGenerated.data.pagination?.total ?? 0)
  );
}

export function buildNonGeneratedAssetsProbeUrl(
  tenantId: string,
  productId: string
): string {
  return buildAssetsProbeUrl("product", tenantId, productId, {
    includeGeneratedAssets: false,
  });
}
